module.exports = __webpack_public_path__ + "static/media/ic-print.c50f7ae7.svg";